import { __decorate, __metadata, __param } from "tslib";
import { Inject, Injectable } from 'angular-ts-decorators';
import { YoukuVideoProvider, YoutubeProvider } from '../providers/video-provider';
import { YoukuThumbnailProvider, YoutubeThumbnailProvider, } from '../providers/video-thumbnail.provider';
var chineseMarketLocale = 'zh-cn';
var VideoService = (function () {
    function VideoService($q, siteLanguage) {
        this.$q = $q;
        this.siteLanguage = siteLanguage;
        this.videoProviderInitialized = false;
        this.thumbnailVideoProviderInitialized = false;
        this.videoProviderDeferred = this.$q.defer();
        this.thumbnailVideoProviderDeferred = this.$q.defer();
    }
    VideoService.prototype.provider = function () {
        if (this.videoProviderInitialized === true) {
            return this.videoProviderDeferred.promise;
        }
        this.videoProviderInitialized = true;
        var provider;
        if ((this.siteLanguage || '').toLocaleLowerCase() === chineseMarketLocale) {
            provider = new YoukuVideoProvider();
        }
        else {
            provider = new YoutubeProvider();
        }
        this.videoProviderDeferred.resolve(provider);
        return this.videoProviderDeferred.promise;
    };
    VideoService.prototype.thumbnailProvider = function () {
        if (this.thumbnailVideoProviderInitialized) {
            return this.thumbnailVideoProviderDeferred.promise;
        }
        this.thumbnailVideoProviderInitialized = true;
        var provider;
        if ((this.siteLanguage || '').toLocaleLowerCase() === chineseMarketLocale) {
            provider = new YoukuThumbnailProvider();
        }
        else {
            provider = new YoutubeThumbnailProvider();
        }
        this.thumbnailVideoProviderDeferred.resolve(provider);
        return this.thumbnailVideoProviderDeferred.promise;
    };
    VideoService.$inject = ['$q', 'siteLanguage'];
    VideoService = __decorate([
        Injectable('videoService'),
        __param(0, Inject('$q')),
        __param(1, Inject('siteLanguage')),
        __metadata("design:paramtypes", [Function, String])
    ], VideoService);
    return VideoService;
}());
export { VideoService };
